import aaaabbbb from "../assets/images/portraits/aaaabbbb.jpg";
import p197690298 from "../assets/images/portraits/197690298_4485899301443394_663002923665184906_n.jpg";
import p463916176 from "../assets/images/portraits/463916176_9087122007987744_6240820596797690358_n.jpg";
import p649507662 from "../assets/images/portraits/649507662_26752584167681589_1959370434662178107_n.jpg";
import p650980084 from "../assets/images/portraits/650980084_26769887275951278_2524375220019404616_n.jpg";
import p746399616 from "../assets/images/portraits/746399616_28201623979444260_4642076841228454178_n.jpg";
import p49652622 from "../assets/images/portraits/49652622_2298721326827880_1196134961573265408_n.jpg";
import p652502602 from "../assets/images/portraits/652502602_26792487073691298_8104733661610176945_n.jpg";

/**
 * Sightings of the subject over the years. Every photo on the board is used exactly once:
 * the studio portrait lives on the subject file and the sketch on the final report
 * (see profile.js), so neither appears here.
 */
export const portraitEvidence = [
  { id: "sighting-grad", src: p49652622, label: "Earliest record", alt: "Joseph as a child in a white graduation cap and gown" },
  { id: "sighting-station", src: p463916176, label: "Archive", alt: "Joseph laughing outside at night" },
  { id: "sighting-stripes", src: p650980084, label: "Archive", alt: "Joseph in a striped shirt indoors" },
  { id: "sighting-shore", src: p649507662, label: "Field · shoreline", alt: "Joseph taking a photo of himself by the sea" },
  { id: "sighting-tie", src: p652502602, label: "Field · white shirt, tie", alt: "Joseph in a white shirt and tie under a blue sky" },
  { id: "sighting-closeup", src: p197690298, label: "Close-up", alt: "Close-up of Joseph in an orange shirt" },
  { id: "sighting-cap", src: aaaabbbb, label: "Off duty", alt: "Joseph in a backwards cap in front of stone figures" },
  {
    id: "sighting-keyboard",
    src: p746399616,
    label: "At the keyboard",
    alt: "Joseph in a red beanie and glasses, typing on a laptop",
    match: true,
  },
];
